import { Button } from '@fluentui/react-components';
import React, { ReactNode } from 'react';

export const renderPageButtons = (
  fromPage: number,
  toPage: number,
  clickHandler: (page: number) => void,
): ReactNode[] => {
  const buttons: ReactNode[] = [];
  for (let i = fromPage; i <= toPage; i++) {
    buttons.push(
      <Button
        className="pageButton"
        appearance="subtle"
        onClick={() => clickHandler(i)}
        key={i}
      >
        {i}
      </Button>,
    );
  }
  return buttons;
};

export const applyPaginatorOnArray = (
  data: any[],
  page: number,
  itemsPerPage: number,
): any[] => {
  const startIndex = (page - 1) * itemsPerPage;
  return [...data].splice(startIndex, itemsPerPage);
};

export const getQuantityOfPages = (
  quantityAllData: number,
  itemsPerPage: number,
) => Math.ceil((1.0 * quantityAllData) / itemsPerPage);
